<template>
  <div class="box">
    <div v-html="privacy_policy"></div>
  </div>
</template>
<script>
/**
 * Created by www.xingnuocn.com
 * @title：隐私政策
 *
 * @author: 刘嘉鑫
 * @version  V1.0
 * @datecreate: 2022-05-23 18:25
 */
export default {
  data() {
    return {
      privacy_policy: "",
    };
  },
  mounted() {
    document.title = "隐私政策";
    let type = this.$route.query.type; // 1:商家  2:技师
    let url, data;
    if (type == 1) {
      url = `${this.$root.baseUrlTwo}/baselogin/agreement`;
      data = {
        type: 1,
      };
    } else if (type == 2) {
      url = `${this.$root.baseUrlTwo}/baselogin/agreement`;
      data = {
        type: 2,
      };
    } else {
      url = `${this.$root.baseUrlTwo}/login/agreement`;
      data = {};
    }
    this.$axios({
      method: "post",
      headers: {
        "Content-Type": "application/json",
        // "Content-Type": "application/x-www-form-urlencoded",
      }, // 请求头
      url: url,
      data: data,
    }).then((result) => {
      this.privacy_policy = result.data.data.privacy_policy; // 用户头像
    });

    console.log(window.location)
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.box {
  padding: 20px;
}

::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>